export const organizationSidebarStyle = {
  firstMainTree: {
    '&:hover': {
      background: 'var(--primary-100)',
    },
  },
  header: {
    boxShadow: 'var(--box-shadow--1)',
    backgroundColor: 'var(--default-white)',
  },
  wrap: {
    height: 'calc(100vh - 80px)',
    position: 'sticky',
    top: '80px',
    alignSelf: 'flex-start',
    overflow: 'hidden',
    display: 'flex',
    maxWidth: '290px',
    width: '100%',
    // height: '100vh',
    // position: 'sticky',
    // top: '0px',

    paddingRight: '24px',
    paddingLeft: '24px',
    borderRight: '1px solid var(--neutral-100)',
    background: 'var(--default-white)',
    boxShadow: '0px 4px 5px -7px rgba(40, 103, 131, 0.6) inset, var(--box-shadow--1)',

    '&:after': {
      content: "''",
      position: 'absolute',
      left: '-1000px',
      boxShadow: '0px 4px 5px -7px rgba(40, 103, 131, 0.6) inset',
      width: '1000px',
      backgroundColor: 'var(--default-white)',
      height: ' 100%',
    },
  },

  buttonCreate: {
    fontWeight: 700,
    marginTop: '24px',
  },

  spacer: {
    flex: '1 1',
  },

  sidebar: {
    width: '100%',
    // minWidth: '250px',
    height: '100%',
    // maxHeight: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',

    // overflowY: 'scroll',
    overflowY: 'auto',
    overflowX: 'hidden',

    scrollbarColor: 'transparent transparent',
    scrollbarWidth: 'thin',

    // Для Chrome / Safari / Edge (робимо повзунок прозорим)
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent',
      borderRadius: '4px',
      transition: 'background-color 0.3s ease',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },

    '&:hover': {
      // Для Firefox: робимо повзунок сірим
      scrollbarColor: 'var(--neutral-200) transparent',

      // Для Chrome / Safari / Edge: робимо повзунок сірим
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'var(--neutral-200)',
      },
    },

    '& button': {
      height: '44px',
      flexShrink: 0,
    },
  },

  menu: {
    display: 'flex',
    flexDirection: 'column',
    '& svg path': {
      fill: 'var(--primary-600)',
    },

    '& > a.active': {
      background: 'var(--primary-100)',
      color: 'var(--primary-500) !important',

      '& svg path': {
        fill: 'var(--primary-500)',
      },
    },

    '& a:hover': {
      background: 'var(--primary-100)',
    },
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '12px',
    alignItems: 'center',
    height: '40px',
    padding: '10px 16px',
    marginBottom: '8px',
    color: 'var(--neutral-400)',
    fontSize: '16px',
    lineHeight: '24px',
    transition: '.3s',
    borderRadius: '8px',
  },

  icon: {
    width: '28px',
    height: '28px',
    padding: '4px',
    transition: 'all 0.3s ease',

    '&:hover': {
      background: 'var(--primary-200)',
      borderRadius: '6px',

      '& svg path': {
        fill: 'var(--primary-600)',
      },
    },
  },

  iconDisabled: {
    width: '28px',
    height: '28px',
    padding: '4px',
    pointerEvents: 'none',
    opacity: 0.4,
  },

  disabled: {
    cursor: 'default',
    opacity: 0.5,

    '&:hover': {
      background: 'transparent',
    },
  },

  menuTreeItem: {
    padding: '0 16px',
    marginBottom: '8px',
  },

  tree: {
    width: '100%',
    'li ul li .MuiTreeItem-content .MuiTreeItem-label': {padding: '0', borderRadius: '8px', a: {borderRadius: '8px'}},
    '.MuiTreeItem-content': {
      position: 'relative',
      width: '100%',
      borderRadius: '8px',
      padding: 0,
      background: 'none',

      '&.Mui-focused.Mui-selected, &.Mui-selected, &.Mui-selected:hover, &:hover': {
        background: 'none',
      },

      '.MuiTreeItem-label': {
        color: 'var(--neutral-400)',
        padding: '8px 0',
        borderRadius: '8px',
        paddingLeft: 0,

        '.MuiBox-root': {
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        },
        a: {
          padding: '10px 5px',
          width: '100%',
          height: '100%',
        },
      },

      '.MuiTreeItem-iconContainer': {
        position: 'absolute',
        width: '20px',
        right: '0',
        zIndex: 1,
        marginRight: 0,
      },
    },

    '.Mui-selected.Mui-focused': {
      background: 'none',
    },

    '.MuiCollapse-root': {
      marginLeft: '16px',
      position: 'relative',

      '.MuiTreeItem-content': {
        background: 'none',
        '&:hover': {
          background: 'none',
        },
      },

      '&::before': {
        content: '" "',
        display: 'block',
        position: 'absolute',
        top: '19px',
        left: '0',
        width: '1px',
        height: 'calc(100% - 38px)',
        backgroundColor: 'var(--neutral-100)',
      },

      '.MuiTreeItem-label': {
        marginLeft: '23px',
        position: 'relative',
        background: 'none',

        '&::before': {
          content: '" "',
          display: 'block',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          left: '-25px',
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          backgroundColor: 'var(--neutral-100)',
        },
      },

      '.Mui-selected .MuiTreeItem-label': {
        background: 'var(--primary-100)',
        color: 'var(--primary-500)',
        borderRadius: '8px',

        '&::before': {
          backgroundColor: 'var(--primary-500)',
        },
      },
    },
  },
  arrowTop: {
    transform: 'rotate(180deg)',
  },
  sendMailModal: {
    '.MuiPaper-root': {
      width: '100%',
      minWidth: '750px',
      padding: '48px',
    },
  },

  newEventModal: {
    '.MuiPaper-root': {
      position: 'relative',
      minWidth: '1170px',
      width: '100%',
      maxHeight: 'calc(100% - 48px)',
      height: '100%',
      paddingTop: '48px',
      margin: '0 15px',
      borderRadius: '8px 8px 0 0 ',
    },

    '&.MuiDialog-root': {
      height: 'calc(100% - 80px)',
    },
  },
  adminMenu: {
    marginTop: '35px',
  },

  disabledButton: {
    svg: {
      path: {
        fill: 'var(--primary-200)',
      },
    },
  },
};
